import React, { Fragment } from 'react';
import { Row, Col } from 'antd';
import ContainerBody from '@components/ContainerBody';
import Breadcrumb from '@components/Breadcrumb';
import { Add } from './components/Add';
import { useParams } from 'react-router-dom';

const AddConfigs = ({ disabled }) => {
  const { id } = useParams();

  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath={'/dashboard'}
          routeSegments={[
            { name: 'Quản lý cấu hình ghi số', path: '/configs' },
            { name: id ? 'Chỉnh sửa cấu hình' : 'Thêm mới cấu hình' }
          ]}
        />
      </div>
      <Row>
        <Col span={24}>
          <Add disabled={disabled} />
        </Col>
      </Row>
    </ContainerBody>
  );
};

export default AddConfigs;
